<form [formGroup]="transformForm" (ngSubmit)="onSubmit()">
  <div class="cf-flex-column" formGroupName="position">
    <div class="cf-flex-row cf-gap-10 cf-flex-1 cf-justify-content-center cf-align-items-start">
      <span class="flex-20-percent">Position</span>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>x</mat-label>
        <input matInput placeholder="x" formControlName="x" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>y</mat-label>
        <input matInput placeholder="y" formControlName="y" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>z</mat-label>
        <input matInput placeholder="z" formControlName="z" (blur)="onSubmit()" />
      </mat-form-field>
    </div>
  </div>
  <div class="cf-flex-column" formGroupName="scale">
    <div class="cf-flex-row cf-gap-10 cf-flex-1 cf-justify-content-center cf-align-items-start">
      <span class="flex-20-percent">Scale</span>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>x</mat-label>
        <input matInput placeholder="x" formControlName="x" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>y</mat-label>
        <input matInput placeholder="y" formControlName="y" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>z</mat-label>
        <input matInput placeholder="z" formControlName="z" (blur)="onSubmit()" />
      </mat-form-field>
    </div>
  </div>
  <div class="cf-flex-column" formGroupName="rotation">
    <div class="cf-flex-row cf-gap-10 cf-flex-1 cf-justify-content-center cf-align-items-start">
      <span class="flex-20-percent">Rotation</span>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>x</mat-label>
        <input matInput placeholder="x" formControlName="x" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>y</mat-label>
        <input matInput placeholder="y" formControlName="y" (blur)="onSubmit()" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="cf-flex-1">
        <mat-label>z</mat-label>
        <input matInput placeholder="z" formControlName="z" (blur)="onSubmit()" />
      </mat-form-field>
    </div>
  </div>
  <button style="display: none" type="submit"></button>
</form>
